import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, payload) => {
  try {
    const token = rootState['DATA-ACCESS'].tokenAuth;
    const url = new URL(`${URI_GUARD_REQUEST}serpro/sended`);
    const opts = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'user-token': rootState['DATA-ACCESS'].userToken,
      },
      body: JSON.stringify(payload),
    };
  
    const response = await fetch(url, opts);
    const jsonResult = await response.json();
  
    if (jsonResult.errors) {
      return Promise.reject(jsonResult.errors);
    }
  
    return jsonResult;
  } catch (error) {
    return Promise.reject(error);
  }
};
